module.exports = __webpack_public_path__ + "static/media/1-lira-yazi.9b70882e.png";